import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from "mobx";
import moment from "moment";
import { DATE_TIME_FORMAT, emptyValue } from "../../constants/common-constants";
import fotaViewTypeEnum, { ModuleToOpen } from "../../constants/fota-view-type-enum";
import URLConstants from "../../constants/url.constants";
import { getLanguageFromLocalStorage } from "../../helpers/local-stotrage-helper";
import { IObservableInitialState } from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { IAddUpdateFotaMzlConfig, IFotaHostConfig, IFotaMzlConfig, IFotaMzlConfigDetail, IFotaMzlConfigList, IFotaMzlConfigListVM } from "../../models/response/IFotaNewResponse";

import { getInitialFotaMzlConfigListState } from "../initial-state/get-fota-new-list-state";
import * as baseService from "../service/base-service"; import { formatMessage } from "../../translations/format-message";
import toast from "react-hot-toast";
import { addEditFotaMzlConfigInitialState } from "../initial-state/add-edit-fota-mzl-config-initial-state";
;

export class FotaMzlReleaseStore {
  initialStateValue = {
    success: false,
    error: '',
    inProgress: false
  }
  error: string | null = null;
  inProgress: boolean = false;
  isAddUpdatePopupOpen: boolean = false;
  isFilterPopupOpen: boolean = false;
  isSelectedView: {
    view: fotaViewTypeEnum,
    moduleToOpen: ModuleToOpen,
    isViewChanged: boolean
  } = { view: fotaViewTypeEnum.Modem, moduleToOpen: ModuleToOpen.Config, isViewChanged: false };



  fotaModemConfigList: IFotaMzlConfigListVM = getInitialFotaMzlConfigListState;
  fotaJetConfigList: IFotaMzlConfigListVM = getInitialFotaMzlConfigListState;


  deleteFotaMzlConfigState: IObservableInitialState = { ...this.initialStateValue }
  fotaHostConfigDetail: IFotaHostConfig | undefined = undefined;
  addUpdateFotaState: IObservableInitialState = { ...this.initialStateValue }
  fotaMzlConfigDetailState: IObservableInitialState = { ...this.initialStateValue }
  fotaMzlConfigDetail: IFotaMzlConfig | undefined = undefined;

  constructor() {
    makeObservable(this, {
      inProgress: observable,
      error: observable,

      isSelectedView: observable,
      addUpdateFotaState: observable,
      fotaModemConfigList: observable,
      fotaJetConfigList: observable,
      isAddUpdatePopupOpen: observable,
      deleteFotaMzlConfigState: observable,
      fotaMzlConfigDetailState: observable,
      fotaMzlConfigDetail: observable,

      setSelectedView: action,
      setIsAddUpdatePopupOpen: action,

      GetMzlFotaModemConfigListService: action,
      getFotaModemConfigList: computed,

      GetMzlFotaJetConfigListService: action,
      getFotaJetConfigList: computed,

      GetFotaModemConfigByIdService: action,
      getFotaModemConfigDetail: computed,
      GetFotaJetConfigByIdService: action,
      getFotaJetConfigDetail: computed,

      AddFotaModemConfigService: action,
      AddFotaJetConfigService: action,
      DeleteFotaModemConfigService: action,
      DeleteFotaJetConfigService: action,

      reset: action,
      resetAddUpdateFotaState: action,
      resetDeleteFotaMzlConfigState: action,

    });
  }

  /**
   * Fetches a list of mzl Fota modem items. Need change url and result values of api 
   * @param currentPage - Current page number.
   * @param pageSize - Number of items per page.
   */

  GetMzlFotaModemConfigListService = (currentPage: number, pageSize: number) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetFotaModemConfigList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaMzlConfigListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaModemConfigList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  /**
    * This function is used to map fotaModemConfigList to Fota List suitable for Grid Component.
    * @returns Initial Fota Details
    */
  get getFotaModemConfigList(): IFotaMzlConfigList[] {
    if (this.fotaModemConfigList && this.fotaModemConfigList?.Configs.length > 0)
      return this.fotaModemConfigList?.Configs.map((fota) => {
        let language = getLanguageFromLocalStorage();
        return {
          Id: fota.Id,
          EffectiveDateTimestamp: fota.EffectiveDateTimestamp ? moment(fota.EffectiveDateTimestamp).format(DATE_TIME_FORMAT) : "",
          Version: fota.Version,
          ConfigName: fota.ConfigName || "",
          Description: fota.Description ? fota.Description : "",
          FileName: fota.FileName ? fota.FileName : emptyValue,
          FileType: fota.FileType,
          File: fota.File ? fota.File : "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language,
          isEdit: true,
          isDelete: true
        }
      })
    return [];
  }

  GetMzlFotaJetConfigListService = (currentPage: number, pageSize: number) => {
    runInAction(() => (this.inProgress = true));
    let url = `${URLConstants.GetFotaJetConfigList}?PageNo=${currentPage}&PageSize=${pageSize}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaMzlConfigListVM>>) => {
        if (response.data.Error) {
          runInAction(
            () => (this.error = response.data.Message)
          );
        } else {
          runInAction(() => {
            this.fotaJetConfigList = response.data.Data;
          });
        }
      })
      .catch((err) => {
        runInAction(() => (this.error = err));
      })
      .finally(() => {
        runInAction(() => (this.inProgress = false));
      });
  };

  /**
    * This function is used to map fotaJetConfigList to Fota List suitable for Grid Component.
    * @returns Initial Fota Details
    */
  get getFotaJetConfigList(): IFotaMzlConfigList[] {
    if (this.fotaJetConfigList && this.fotaJetConfigList?.Configs.length > 0)
      return this.fotaJetConfigList?.Configs.map((fota) => {
        let language = getLanguageFromLocalStorage();
        return {
          Id: fota.Id,
          EffectiveDateTimestamp: fota.EffectiveDateTimestamp ? moment(fota.EffectiveDateTimestamp).format(DATE_TIME_FORMAT) : "",
          Version: fota.Version,
          ConfigName: fota.ConfigName || "",
          Description: fota.Description ? fota.Description : "",
          FileName: fota.FileName ? fota.FileName : emptyValue,
          FileType: fota.FileType,
          File: fota.File ? fota.File : "",
          CreatedBy: fota.CreatedBy,
          UpdatedBy: fota.UpdatedBy,
          CreatedDate: fota.CreatedDate ? moment(fota.CreatedDate).format(DATE_TIME_FORMAT) : "",
          UpdatedDate: fota.UpdatedDate ? moment(fota.UpdatedDate).format(DATE_TIME_FORMAT) : "",
          Language: language,
          isEdit: true,
          isDelete: true
        }
      })
    return [];
  }

  AddFotaModemConfigService = (data: IFotaMzlConfigDetail) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaModemConfig;
    return baseService.postRequest(url, { ...data }).then(
      (
        response: IApiResponse<IApiSuccessResponse<boolean>>
      ) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateFotaState.success = true;
        }
      }
    )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  AddFotaJetConfigService = (data: IFotaMzlConfigDetail) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaJetConfig;
    return baseService.postRequest(url, { ...data }).then(
      (
        response: IApiResponse<IApiSuccessResponse<boolean>>
      ) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateFotaState.success = true;
        }
      }
    )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  UpdateFotaModemConfigService = (data: IFotaMzlConfigDetail, id: number) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaModemConfig;
    return baseService.putRequest(url, { ...data, Id: id })
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.addUpdateFotaState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  UpdateFotaJetConfigService = (data: IFotaMzlConfigDetail, id: number) => {
    this.addUpdateFotaState.inProgress = true;
    const url = URLConstants.FotaJetConfig;
    return baseService.putRequest(url, { ...data, Id: id })
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<boolean>>
        ) => {
          if (response.data.Error) {
            toast.error(formatMessage(response.data.Message));
          } else {
            this.addUpdateFotaState.success = true;
          }
        }
      )
      .catch((err: any) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        this.addUpdateFotaState.inProgress = false;
      });
  };

  DeleteFotaModemConfigService = (id: number) => {
    this.deleteFotaMzlConfigState.inProgress = true;
    let url = `${URLConstants.FotaModemConfig}/${id}`;
    return baseService.deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteFotaMzlConfigState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else this.deleteFotaMzlConfigState.success = true;
      })
      .catch((err: string) => {
        this.deleteFotaMzlConfigState.error = err;
      }).finally(action(() => { this.deleteFotaMzlConfigState.inProgress = false; }));
  }
  DeleteFotaJetConfigService = (id: number) => {
    this.deleteFotaMzlConfigState.inProgress = true;
    let url = `${URLConstants.FotaJetConfig}/${id}`;
    return baseService.deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteFotaMzlConfigState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        }
        else this.deleteFotaMzlConfigState.success = true;
      })
      .catch((err: string) => {
        this.deleteFotaMzlConfigState.error = err;
      }).finally(action(() => { this.deleteFotaMzlConfigState.inProgress = false; }));
  }

  GetFotaModemConfigByIdService = (id: number) => {
    runInAction(() => (this.fotaMzlConfigDetailState.inProgress = true));
    const url = `${URLConstants.FotaModemConfig}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaMzlConfig>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotaMzlConfigDetail = {
              ...response.data.Data,
            };
            this.fotaMzlConfigDetailState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        runInAction(() => (this.fotaMzlConfigDetailState.inProgress = false));
      });
  };

  get getFotaModemConfigDetail(): IAddUpdateFotaMzlConfig {
    if (this.fotaMzlConfigDetail)
      return {
        ...this.fotaMzlConfigDetail,
        File: "",
        FileContent: this.fotaMzlConfigDetail?.File ? this.fotaMzlConfigDetail?.File : "",
        FileName: "",
        WantToUpdateFile: "false",
      };
    else
      return { ...addEditFotaMzlConfigInitialState }
  }

  GetFotaJetConfigByIdService = (id: number) => {
    runInAction(() => (this.fotaMzlConfigDetailState.inProgress = true));
    const url = `${URLConstants.FotaJetConfig}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IFotaMzlConfig>>) => {
        if (response.data.Error) {
          toast.error(formatMessage(response.data.Message));
        } else {
          runInAction(() => {
            this.fotaMzlConfigDetail = {
              ...response.data.Data,
            };
            this.fotaMzlConfigDetailState.success = true;
          });
        }
      })
      .catch((err) => {
        toast.error(formatMessage(err));
      })
      .finally(() => {
        runInAction(() => (this.fotaMzlConfigDetailState.inProgress = false));
      });
  };

  get getFotaJetConfigDetail(): IAddUpdateFotaMzlConfig {
    if (this.fotaMzlConfigDetail)
      return {
        ...this.fotaMzlConfigDetail,
        File: "",
        FileContent: this.fotaMzlConfigDetail?.File ? this.fotaMzlConfigDetail?.File : "",
        FileName: "",
        WantToUpdateFile: "false",
      };
    else
      return { ...addEditFotaMzlConfigInitialState }
  }

  resetAddUpdateFotaState = () => {
    this.fotaMzlConfigDetail = undefined;
    this.addUpdateFotaState = { ...this.initialStateValue };
  }
  resetDeleteFotaMzlConfigState = () => {
    this.deleteFotaMzlConfigState = { ...this.initialStateValue };
  };


  /**
   * Resets all observables to their initial values.
   */
  reset = () => {
    this.addUpdateFotaState = { ...this.initialStateValue };
  };


  setSelectedView = (data: { view: fotaViewTypeEnum, moduleToOpen: ModuleToOpen, isViewChanged: boolean }) => {
    this.isSelectedView = { ...data };
    localStorage.setItem('mzl_selected_view', JSON.stringify({ view: data.view, moduleToOpen: data.moduleToOpen }))
  }

  setIsAddUpdatePopupOpen = (flag: boolean) => {
    this.isAddUpdatePopupOpen = flag
  }

  setIsFilterPopupOpen = (flag: boolean) => {
    this.isFilterPopupOpen = flag
  }



}
const fotaMzlReleaseStore = new FotaMzlReleaseStore();
export default fotaMzlReleaseStore;
